import React from "react";
import { ErrorField } from "components/ui/error-field";

const CourierNativeSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder,
  error,
  required,
  disabled,
  span = false
}) => {
  const stringValue = value === "" || value == null ? "" : String(value);

  const handleChange = e => {
    const raw = e.target.value;
    if (raw === "") {
      onChange({ target: { name, value: "" } });
      return;
    }
    const match = options.find(o => String(o.value) === raw);
    onChange({ target: { name, value: match ? match.value : raw } });
  };

  return (
    <div className={`dropdown-area${span ? " span-all" : ""}`}>
      {label && <span className="label-text">{label}</span>}
      <select
        name={name}
        value={stringValue}
        required={required}
        disabled={disabled}
        onChange={handleChange}
      >
        <option value="">{placeholder || "Select"}</option>
        {options.map(option => (
          <option key={String(option.value)} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
      {error ? <ErrorField value={String(error)} /> : null}
    </div>
  );
};

export default CourierNativeSelect;
